import { useContext } from "react";
import { AppContext } from "../../context/index";
import { SubheaderActions } from "iuvity-ui-components/dist/subheaderactions";
import { Tag } from "iuvity-ui-components/dist/tag";
import { Button } from "iuvity-ui-components";
import { useNavigate } from "react-router-dom";
import jp from "jsonpath";

interface BaseRoleListProps {
  title: string;
  data: any;
};

export const BaseRoleList: React.FC<BaseRoleListProps> = ({
  title,
  data,
}) => {
  const {
    appState: { infoObjRolesByTenantState: {
      dataRolesByTenantGlobal,
      functionalitiesCodesMap,
    }},
    t,
  } = useContext(AppContext);
  const navigate = useNavigate();

  const adminRolesPrivileges = (!!dataRolesByTenantGlobal && !!functionalitiesCodesMap)
    && jp.query(dataRolesByTenantGlobal, `$..[?(@.functionalityId=="${functionalitiesCodesMap['/adminroles']}")].permission.privilegeId`);

  return (
    <div className="base-role-list-container">
      <div className="title">
        {title}
      </div>

      <SubheaderActions
          className="m-0 p-0"
          actions={[
            {
              id: "111",
              icon: "iu iu-icon-plus",
              label: t("Dashboard.createBaseRoleBtn"),
              style: {
                display: (!!adminRolesPrivileges && !adminRolesPrivileges?.includes('CREATE')) ? 'none' : undefined,
              },
              onClick: () => navigate('/adminroles/newroles'),
            },
          ]}
        />
        
      {data?.map((rol: any) => (
        <div className="role-list" key={rol.id}>
          <div>
            <div className="role-title">{rol.name}</div>
            <div className="role-subtitle">{rol.description}</div>
          </div>
          <div className="role-status">
            <Tag
              value={t(`Roles.${rol.statusId}Label`)}
              severity={
                (['active', 'activo'].includes(rol.statusId.toLowerCase()) && 'success') ||
                (['draft', 'borrador'].includes(rol.statusId.toLowerCase()) && 'info') ||
                (['deleted', 'eliminado'].includes(rol.statusId.toLowerCase()) && 'danger') ||
                'warning'
              }
            />
          </div>
        </div>
      ))}

      <div className="see-more">
        <Button
          id='see-more-icon'
          className="iu iu-icon-arrowsright mt-4"
          label={t('Dashboard.seeMoreRolesBtn')}
          variant="p-button-link"
          onClick={() => navigate('/adminroles')}
          icon="iu iu-icon-arrowsright"
          iconPos="left"
        />
      </div>
    </div>
  );
};
